import { Card } from "react-bootstrap";
import CountUp from "react-countup";
import { FC, useEffect, useState } from "react";
// import Loader from "Common/Loader";
// import BeatLoader from "react-spinners/BeatLoader";
import Select from "react-select";
import { settingServices } from "Utils/setting/services";

interface Props {}

const TotalClientPl: FC<Props> = () => {
  const [selfData, setSelfData] = useState<any>();
  const [childData, setChildData] = useState<any>();
  const [options, setOptions] = useState<{ label: string; value: string }[]>(
    []
  );
  const [selectedOption, setSelectedOption] = useState<any>(null);

  const getDiamondUserList = async (user_name: string) => {
    const { response } = await settingServices.getDiamondUserList({
      belong_to: "DIAMOND",
      limit: 25,
      page: 1,
      search: {
        user_name,
      },
    });
    if (response?.data?.data?.length > 0) {
      const formattedOptions = response?.data?.data?.map((item: any) => ({
        label: item.name,
        value: item._id,
      }));
      setOptions(formattedOptions);
    }
  };

  const getClientPLSum = async (users: string[]) => {
    const { response } = await settingServices.getClientPLSum({
      child_user_ids: users,
    });
    if (response) {
      setSelfData(response?.data?.selfData);
      const totalClientPLShare = response?.data?.childData?.reduce(
        (total: any, currentItem: any) => total + currentItem.client_pl_share,
        0
      );
      setChildData(totalClientPLShare);
    }
  };

  const handleSelectChange = (selected: any) => {
    setSelectedOption(selected);
    const users = selected?.map((item: any) => item.value) || [];

    getClientPLSum(users);
  };

  useEffect(() => {
    getClientPLSum([]);
  }, []);

  const handleInputChange = (inputValue: string) => {
    if (inputValue?.length >= 3) {
      getDiamondUserList(inputValue);
    }
  };

  return (
    <>
      <Card className="card-height-100">
        <Card.Header className="d-flex border-bottom pb-3">
          <h5 className="card-title mb-0 flex-grow-1">Total Client PL</h5>
        </Card.Header>
        <div className="p-2">
          <Select
            isClearable
            isMulti
            options={options}
            value={selectedOption}
            onChange={handleSelectChange}
            onInputChange={(inputValue: string) =>
              handleInputChange(inputValue)
            }
            className="customSelect"
          />
        </div>

        <div className="card-body text-center d-flex justify-content-around">
          <div>
            <h4>
              <CountUp
                start={0}
                end={selfData?.client_pl_share?.toFixed(2) || 0}
              />
            </h4>

            <p className="text-muted mb-0">Total WL PL</p>
          </div>
          <div>
            <h4>
              <CountUp start={0} end={childData?.toFixed(2) || 0} />
            </h4>

            <p className="text-muted mb-0">Total Clien PL</p>
          </div>
          <div>
            <h4>
              <CountUp
                start={0}
                end={(selfData?.client_pl_share + childData)?.toFixed(2)}
              />
            </h4>

            <p className="text-muted mb-0">Total PL</p>
          </div>
        </div>
      </Card>
      {/* {isLoading?.[loadingType] && (
          <div
            className="position-absolute top-0 start-0 h-100 w-100 d-flex align-items-center justify-content-center"
            style={{ zIndex: "99999", background: "rgba(255,255,255,.75)" }}
          >
            <BeatLoader />
          </div>
        )} */}
    </>
  );
};

export default TotalClientPl;
